import { __extends } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextProvider } from 'uitk-react-utils';
import { UitkSheet } from 'uitk-react-sheet';
import styles from './uitk-dialog.css';

var getClassNameList = classNames.bind(styles);
var UitkDialogAnimationType;
(function (UitkDialogAnimationType) {
    UitkDialogAnimationType["NONE"] = "none";
    UitkDialogAnimationType["FADE"] = "fade";
    UitkDialogAnimationType["SLIDEDOWN"] = "slidedown";
    UitkDialogAnimationType["SLIDELEFT"] = "slideleft";
    UitkDialogAnimationType["SLIDERIGHT"] = "slideright";
    UitkDialogAnimationType["SLIDEUP"] = "slideup";
})(UitkDialogAnimationType || (UitkDialogAnimationType = {}));
var UitkDialog = /** @class */ (function (_super) {
    __extends(UitkDialog, _super);
    function UitkDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.focusableElements = [];
        _this.containerElements = [];
        _this.iphoneSafariUARegex = /iphone.*safari|safari.*iphone/gi;
        _this.setDialogHeightForSafariOnIphone = _this.setDialogHeightForSafariOnIphone.bind(_this);
        _this.setHeight = _this.setHeight.bind(_this);
        _this.detectIphoneSafariPortrait = _this.detectIphoneSafariPortrait.bind(_this);
        return _this;
    }
    UitkDialog.prototype.componentDidMount = function () {
        this.detectIphoneSafariPortrait() && this.setDialogHeightForSafariOnIphone();
    };
    UitkDialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setHeight);
    };
    UitkDialog.prototype.setHeight = function () {
        document.documentElement.style.setProperty('--vh', "".concat(window.innerHeight, "px"));
    };
    UitkDialog.prototype.setDialogHeightForSafariOnIphone = function () {
        this.setHeight();
        window.addEventListener('resize', this.setHeight);
    };
    UitkDialog.prototype.detectIphoneSafariPortrait = function () {
        return (typeof window !== 'undefined' &&
            typeof navigator !== 'undefined' &&
            !!navigator.userAgent.match(this.iphoneSafariUARegex) &&
            typeof window.matchMedia === 'function' &&
            window.matchMedia('(orientation: portrait)').matches);
    };
    UitkDialog.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, autoFocus = _a.autoFocus, children = _a.children, className = _a.className, closeCallback = _a.closeCallback, dialogShow = _a.dialogShow, heightAuto = _a.heightAuto, openCallback = _a.openCallback, returnFocusOnClose = _a.returnFocusOnClose, strictFullscreen = _a.strictFullscreen, triggerRef = _a.triggerRef, _b = _a.sheetType, sheetType = _b === void 0 ? 'centered' : _b;
        var defaultRef = React.createRef(); // Adding default Ref in case there's none provided
        if (!children) {
            return null;
        }
        var wrapperClassNames = getClassNameList('uitk-dialog', 'uitk-dialog-sheet', className, {
            'uitk-dialog-fullscreen-strict': strictFullscreen,
            'uitk-dialog-height-auto': heightAuto
        });
        return (React.createElement(UitkContextProvider, { config: { context: 'uitk-dialog-context' } },
            React.createElement(UitkSheet, { autoFocus: autoFocus, returnFocusOnClose: returnFocusOnClose, isVisible: dialogShow, type: sheetType, triggerRef: triggerRef || defaultRef, className: wrapperClassNames, openCallback: openCallback, closeCallback: closeCallback, ariaLabel: ariaLabel, centeredSheetSize: "small" }, children)));
    };
    UitkDialog.displayName = 'UitkDialog';
    UitkDialog.defaultProps = {
        animation: UitkDialogAnimationType.NONE,
        autoFocus: true,
        heightAuto: false,
        returnFocusOnClose: false,
        strictFullscreen: false
    };
    return UitkDialog;
}(React.Component));

export { UitkDialog, UitkDialogAnimationType };
